// Module
var code = "<div class=bible> <h2 class=passageref>2 Timothy 3.10</h2> <div class=bibletext> <p> </p><h2 class=plus-S>Paul&#146;s Charge to Timothy</h2><p><span class=vv>10</span>&nbsp;Now you have observed my teaching, my conduct, my aim in life, my faith, my patience, my love, my steadfastness, </p> </div></div>";
// Exports
module.exports = code;